// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".articleTypeSummary-module_articlelayout_vTsLWbavYt7JBFrUa1zV{display:flex;flex-direction:row}", "",{"version":3,"sources":["webpack://./src/bloks/panels/articleTypeSummary/articleTypeSummary.module.scss"],"names":[],"mappings":"AACA,8DACE,YAAA,CACA,kBAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~@crunchyroll/cx-web-themes/crunchyroll/abstracts/main\";\n.articlelayout {\n  display: flex;\n  flex-direction: row;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articlelayout": "articleTypeSummary-module_articlelayout_vTsLWbavYt7JBFrUa1zV"
};
export default ___CSS_LOADER_EXPORT___;
